import type { DeviceType } from './device-type'

export type EventType = 'page_view'

export interface IIntranetEvent {
  event_type: string
  format_version: string
  local_time: number
  value: string
  version: string
}

export interface IAppEvent extends IDBContextExtendedV2 {
  app_key: string
  date: number
  device_type: string
  event_type: string
  id: string
  value: string
}

export interface IFormattedEvent {
  eventType: TAppEventType
  text: string
  title: string
  x: number
}

export interface IGetAppEventsPayload {
  appKey: string
  deviceType: DeviceType
  endDate?: string
  eventTypes?: string[]
  limit?: number
  startDate?: string
}

export interface ICreateAppEventPayload {
  appKey: string
  date: number
  deviceType: string
  eventType: string
  value: string
}

export interface IUpdateAppEventPayload extends ICreateAppEventPayload {
  eventId: string
}

export interface IDeleteAppEventPayload {
  appKey: string
  deviceType: string
  eventId: string
}

export const appEventTypes = ['new-app-version']

export type TAppEventType = (typeof appEventTypes)[number]

export type TAppEvent = {
  backgroundColor: string
  fontColor: string
  label: string
}

export const APP_EVENTS: Record<TAppEventType, TAppEvent> = {
  'new-app-version': { backgroundColor: '#c6e8dd', fontColor: '#0e4a37', label: 'New app version' },
}
